import {Component, OnInit} from "@angular/core";
import {BaseComponent} from "../../base.component";
import {LoggerService} from "../../common/logger.service";
import {UserService} from "../../common/user.service";
import {ConfirmDialogService} from "../../common/confirm-dialog/confirm-dialog.service";
import {IBodyObject} from "../../common/confirm-dialog/confirm-dialog.model";
import {ActivatedRoute, Router} from "@angular/router";
import {Constants} from "../../constants";
import {noop} from "rxjs";
import {PaymentMethodResponse} from "../../../checkout/models/payment/payment-method";
import {PayPalService} from "./paypal.service";
import {uxCartRouterCommands} from "../../util/locale-util";

@Component({
    selector: 'paypal-token',
    template: `
        <usana-spinner [show]="true"></usana-spinner>`,
    standalone: false
})

export class PayPalTokenComponent extends BaseComponent implements OnInit {

    constructor(
        loggerService: LoggerService,
        userService: UserService,
        private router: Router,
        private route: ActivatedRoute,
        private confirmDialogService: ConfirmDialogService,
        private payPalService: PayPalService,
    ) {
        super(userService, loggerService);
    }

    ngOnInit() {
        const baToken = this.route.snapshot.queryParamMap.get(Constants.PAYPAL_PARAM_BA_TOKEN);
        // returnUrl is a cart-ux relative path (e.g. "checkout"); route via uxCartRouterCommands so it
        // resolves under /ux/cart/:locale — navigateByUrl on the bare path lands in /ux/dotcom (404).
        const returnCommands = uxCartRouterCommands(...decodeURIComponent(this.route.snapshot.queryParamMap.get(Constants.PAYPAL_PARAM_RETURN_URL)).split("/").filter(Boolean));
        this.payPalService.savePayPalAgreementToken(baToken)
            .subscribe((paymentMethodResponse: PaymentMethodResponse) => {
                this.log.debug(`Added payment method ${paymentMethodResponse.paymentSource.id}`);
                this.router.navigate(returnCommands, {queryParams: {paymentMethodId: paymentMethodResponse.paymentSource.id}}).then(noop);
            }, (error) => {
                this.log.error(error);
                const body: IBodyObject[] = [];
                const confirmAction = () => this.router.navigate(returnCommands).then(noop);
                this.confirmDialogService.openError("sm", body, {confirmAction: confirmAction});
            });
    }
}
